(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var bar = document.querySelector('.lp-sticky');
      if (!bar || bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      var showAfter = parseInt(bar.dataset.showAfter, 10) || 0;
      var target = bar.dataset.hideOn ? document.getElementById(bar.dataset.hideOn) : null;
      var link = bar.querySelector('a, button');
      var targetVisible = false;

      function update() {
        var show = window.scrollY > showAfter && !targetVisible;
        bar.classList.toggle('translate-y-full', !show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (link) link.setAttribute('tabindex', show ? '0' : '-1');
        document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
      }
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          targetVisible = entries[0].isIntersecting;
          update();
        }).observe(target);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-value-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(n) {
      return '£' + (Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2));
    }
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var perPerson = parseFloat(root.dataset.perPerson) || 5;
      var perSheet = parseFloat(root.dataset.perSheet) || 0.5;
      var compare = parseFloat(root.dataset.compare) || 0.7;
      var options = root.querySelectorAll('.lp-calc__option');
      var monthlyEl = root.querySelector('[data-calc-monthly]');
      var savingEl = root.querySelector('[data-calc-saving]');
      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var people = parseInt(btn.dataset.people, 10);
          options.forEach(function (b) {
            var on = b === btn;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.classList.toggle('bg-white', on);
            b.classList.toggle('text-cheeky-green', on);
            b.classList.toggle('bg-transparent', !on);
            b.classList.toggle('text-white', !on);
          });
          var monthly = perPerson * people;
          monthlyEl.textContent = money(monthly);
          savingEl.textContent = '£' + Math.round(monthly * 12 * (compare / perSheet - 1));
        });
      });
    }
    function initAll() { document.querySelectorAll('.lp-calc').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
